// extracted by mini-css-extract-plugin
module.exports = {"userLogsContainer":"styles_userLogsContainer__2vk37","top":"styles_top__3e72L"};